document.addEventListener("DOMContentLoaded", () => {
  const carousels = document.querySelectorAll("carousel-component");

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          observer.unobserve(entry.target);
          initializeCarousel(entry.target);
        }
      });
    }, {
      rootMargin: "200px",
      threshold: 0.1,
    });

    carousels.forEach(carousel => observer.observe(carousel));
  } else {
    // Fallback for older browsers
    carousels.forEach(c => initializeCarousel(c));
  }

  function initializeCarousel(element) {
    if (!customElements.get("carousel-component")) {
      class Carousel extends HTMLElement {
        constructor() {
          super();
          this.carouselElement = this;
          this.desktopPerPage = this.dataset["desktopperpage"] || 3;
          this.mobilePerPage = this.dataset["mobileperpage"] || 1;
          this.focus = this.dataset["focus"];
          this.type = this.dataset["type"];
          this.gap = this.dataset["gapbetweenslides"] || 0;
          this.gapMobile = this.dataset["gapbetweenslidesonmobile"] || 0;
          this.autoplaySpeed = parseInt(this.dataset["autoplaySpeed"]) || 3000;
          this.direction = this.dataset["direction"] || "ltr";
          this.mobilePaddingLeft = this.dataset["mobilepaddingleft"] || "0";
          this.mobilePaddingRight = this.dataset["mobilepaddingright"] || "0";
          this.desktopPaddingLeft = this.dataset["desktoppaddingleft"] || "0";
          this.desktopPaddingRight = this.dataset["desktoppaddingright"] || "0";

          this.showarrows = this.dataset["showarrows"] === "true" || false;
          this.autoplay = this.dataset["autoplay"] === "true" || false;
          this.showarrowsonmobile = this.dataset["showarrowsonmobile"] === "true" || false;
          this.showdots = this.dataset["showdots"] === "true" || false;
          this.showdotsonmobile = this.dataset["showdotsonmobile"] === "true" || false;
          this.isNavigation = this.dataset["isnavigation"] === "true" || false;
          this.disableDrag = this.dataset["disabledrag"] === "true" || false;
          this.destroyOnMobile = this.dataset["enableonmobile"] == "false" || false;
          this.destroyOnDesktop = this.dataset["enableondesktop"] == "false" || false;
          this.omitEnd = this.dataset["omitEnd"] == "false" || false;
          this.refresh = this.dataset["refresh"] == "true" || false;
          this.sync = this.dataset["carouselsyncselector"] || false;

          if (!this.classList.contains("splide")) return;

          this.initCarousel();
        }

        initCarousel() {
          if (this.destroyOnMobile && this.destroyOnDesktop) return;

          this.carousel = new Splide(this.carouselElement, {
            perPage: this.desktopPerPage,
            ...(this.type ? { type: this.type } : {}),
            ...(this.focus ? { focus: this.focus } : {}),
            autoplay: this.autoplay,
            interval: this.autoplaySpeed,
            gap: this.gap,
            arrows: this.showarrows,
            pagination: this.showdots,
            isNavigation: this.isNavigation,
            drag: !this.disableDrag,
            direction: this.direction,
            destroy: this.destroyOnDesktop,
            padding: {
              left: this.desktopPaddingLeft,
              right: this.desktopPaddingRight,
            },
            omitEnd: this.omitEnd,
            breakpoints: {
              990: {
                padding: {
                  left: this.mobilePaddingLeft,
                  right: this.mobilePaddingRight,
                },
                perPage: this.mobilePerPage,
                arrows: this.showarrowsonmobile,
                pagination: this.showdotsonmobile,
                gap: this.gapMobile,
                destroy: this.destroyOnMobile,
              },
            },
          });

          if (this.sync) {
            this.initCarouselSync();
          } else {
            this.initProgressBar(this.carousel);
            this.carousel.mount();

            if (this.refresh) this.carousel.refresh();
          }
        }

        initProgressBar(skeletonSplide) {
          const bar = this.querySelector(".my-slider-progress-bar");
          if (!bar) return;

          this.carousel.on("mounted move", function () {
            const end = skeletonSplide.Components.Controller.getEnd() + 1;
            const rate = Math.min((skeletonSplide.index + 1) / end, 1);
            bar.style.width = String(100 * rate) + "%";
          });
        }

        initCarouselSync() {
          this.syncElement = document.querySelector(this.sync);
          this.direction = this.syncElement.dataset["direction"] || "ltr";

          this.carouselSync = new Splide(this.sync, {
            updateOnMove: true,
            perPage: this.syncElement.dataset["desktopperpage"] || 5,
            type: this.syncElement.dataset["type"] || "loop",
            focus: this.syncElement.dataset["focus"] || "center",
            isNavigation: this.syncElement.dataset["isnavigation"] === "true" || false,
            pagination: false,
            arrows: this.syncElement.dataset["showarrows"] === "true" || false,
            drag: true,
            ...(this.direction === "ttb" && {
              height: this.getPrimarySlideFirstImageHeight(),
              direction: "ttb",
              autoHeight: true,
            }),
            breakpoints: {
              989: {
                height: "auto",
                direction: "ltr",
                gap: this.gapMobile,
              },
            },
          });

          this.carousel.sync(this.carouselSync);
          this.carousel.mount();
          this.carouselSync.mount();
        }

        refreshSlider() {
          this.carousel.refresh();
          if (this.carouselSync) {
            this.carouselSync.refresh();
          }
        }

        getPrimarySlideFirstImageHeight() {
          const image = this.querySelector(".splide__list img");
          const containerWidth = this.querySelector(".splide__list").clientWidth;
          const originalWidth = image.getAttribute("width");
          const originalHeight = image.getAttribute("height");

          return (containerWidth / originalWidth) * originalHeight;
        }
      }

      customElements.define("carousel-component", Carousel);
    }

    // Create an instance immediately if it's visible now (race condition fix)
    if (!element.__carouselInitialized) {
      element.__carouselInitialized = true;
      const instance = new Carousel();
      Object.setPrototypeOf(element, Carousel.prototype);
      Carousel.call(element);
    }
  }
});
